import React from 'react';
import { Progress } from '@/components/ui/progress';

export function formatDate(dateStr) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function isOverdue(dateStr) {
  if (!dateStr) return false;
  return new Date(dateStr) < new Date();
}

export function ProductionProgress({ jobCard }) {
  const { production_stages = [], completed_stages = 0, total_stages = 0, current_stage } = jobCard;
  const progressPercent = total_stages > 0 ? (completed_stages / total_stages) * 100 : 0;

  return (
    <div className="mt-2">
      <div className="flex items-center justify-between text-xs text-slate-500 mb-1">
        <span>Production: {completed_stages}/{total_stages} stages</span>
        {current_stage && (
          <span className="text-blue-600 font-medium">
            Current: {current_stage.stage_name}
          </span>
        )}
      </div>
      <Progress value={progressPercent} className="h-1.5" />
    </div>
  );
}
